import { render } from "./perfilComponent.vue?vue&type=template&id=4768fb47"
import script from "./perfilComponent.vue?vue&type=script&lang=js"
export * from "./perfilComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__